module.exports = __webpack_public_path__ + "img/controller.35db9cc5.svg";